import { Link } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import Reveal from "@/components/Reveal";
import SEO, { breadcrumbJsonLd } from "@/components/SEO";

const AUDIENCES = [
  { label: "Startups", body: "From concept, licensure, and staffing to first admission and quality assurance." },
  { label: "Existing Providers", body: "Optimize census, staffing, documentation, and operational sustainability." },
  { label: "Multi-Site Organizations", body: "Standardize systems and processes across locations while preserving local nuance." },
  { label: "Hospitals", body: "Integrate behavioral health services with acute-care operations and workforce." },
  { label: "Nonprofits", body: "Sustainable operations, funder reporting, and mission-aligned people practices." },
  { label: "Private Equity", body: "Diligence, integration, and value creation across behavioral health platforms." },
  { label: "Tribal Organizations", body: "Culturally-grounded behavioral health program development and workforce solutions." },
];

export default function WhoWeServe() {
  return (
    <SiteLayout branch="main">
      <SEO
        title="Who We Serve"
        path="/who-we-serve"
        description="Catalyst BH Consulting serves behavioral-health startups, multi-site providers, hospitals, nonprofits, private-equity portfolios, and tribal organizations nationwide."
        jsonLd={breadcrumbJsonLd([["Home", "/"], ["Who We Serve"]])}
      />
      <section className="section bg-[var(--cream)]">
        <Reveal className="max-w-4xl">
          <span className="eyebrow-dark">WHO WE SERVE</span>
          <h1 className="font-display mt-5 text-[clamp(40px,5vw,68px)] leading-[1.05] text-[var(--navy)]">
            From startup <em className="italic text-[var(--gold)]">to national platform.</em>
          </h1>
        </Reveal>
      </section>

      <section className="section bg-white">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1300px] mx-auto">
          {AUDIENCES.map((a, i) => (
            <Reveal key={a.label} delay={i * 60}>
              <article className="card-editorial min-h-[220px]" data-testid={`audience-${i}`}>
                <h3 className="font-display text-2xl text-[var(--navy)] mb-3">{a.label}</h3>
                <p className="text-[var(--muted)] text-sm leading-relaxed">{a.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-14">
          <Link to="/book" className="btn btn-navy">Discuss Your Organization</Link>
        </div>
      </section>
    </SiteLayout>
  );
}
